import React, { useState } from 'react';

const Disclaimer = props => {
    
    const [isVisible, hideDisclaimer] = useState(true);
    
    if (!isVisible) return null;

    return (
        <div className="report__disclaimer">
            <p><strong>OBS!</strong> Om rapporten innehåller <strong>data äldre än 24 månader</strong> rekommenderar vi er att kontrollera om det tillkommit några nya företag i statistikgrenen och från vilket datum de i så fall har data. Delfi garanterar jämförbar data <strong>24 månader bakåt</strong> i tiden. Kontakta oss vid frågor! <a href="mailto:marknadsdata@delfi.se">marknadsdata@delfi.se</a></p>
            <button className="report__disclaimer-close" type="button" onClick={() => hideDisclaimer(false)}></button>
        </div>
    );
};

export default Disclaimer;